import GamesHubPage from '@/modules/gamification/pages/GamesHubPage.vue'
import GameDashboardPage from '@/modules/gamification/pages/GameDashboardPage.vue'
import GamesCataloguePage from '@/modules/gamification/pages/GamesCataloguePage.vue'

export default [
  {
    name: 'GamesHub',
    path: '/games-hub',
    component: GamesHubPage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    }
  },
  {
    name: 'GamesHubDashboard',
    path: '/games-hub/dashboard',
    component: GameDashboardPage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    }
  },
  {
    name: 'GamesHubCatalogue',
    path: '/games-hub/catalogue',
    component: GamesCataloguePage,
    meta: {
      projectFeatures: {
        items: ['enableGamification'],
        notFound: true
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/modules/gamification/router/index.js